import { EKeyCode } from '@/enums/e_key_code';
import { WATCHER_SHORTCUT__base } from '@/pages/_base/shortcuts/_watchers/WATCHER_SHORTCUT__base';
import { use_component_action_button_auth_with_email_and_password } from '../_hooks/use_component_action_button_auth_with_email_and_password';

interface Props {
  email: string;
  password: string;
}

export function WatcherShortcutAuthWithEmailAndPassword({ email, password }: Props) {
  const { can_try_auth_with_email_and_password, auth_with_email_and_password } = use_component_action_button_auth_with_email_and_password(email, password);

  function on_shortcut_pressed() {
    if (!can_try_auth_with_email_and_password) return false;

    void auth_with_email_and_password();

    return true;
  }

  if (!can_try_auth_with_email_and_password) return null;

  return <WATCHER_SHORTCUT__base key_codes={[EKeyCode.Enter]} {...{ on_shortcut_pressed }} />;
}
